import Reflux from "reflux";
import * as Immutable from "immutable";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import { singletonStore } from "logic/singleton";
import PaginationURL from "util/PaginationURL";
import Role from "logic/roles/Role";
import AuthzRolesActions from "actions/roles/AuthzRolesActions";
import UserOverview from "logic/users/UserOverview";
const _responseToPaginatedList = ({
  count,
  total,
  page,
  per_page,
  query,
  roles = [],
  context = { users: void 0 }
}) => ({
  list: Immutable.List(roles.map((r) => Role.fromJSON(r))),
  pagination: {
    query,
    page,
    perPage: per_page,
    count,
    total
  },
  context
});
const _responseToPaginatedUserList = ({ count, total, page, per_page, query, users }) => ({
  list: Immutable.List(users.map((u) => UserOverview.fromJSON(u))),
  pagination: {
    page,
    perPage: per_page,
    query,
    count,
    total
  }
});
const encodeApiUrl = (apiRoute, uriParams = []) => {
  const encodedUriParams = uriParams.map((param) => encodeURIComponent(param));
  return apiRoute(...encodedUriParams).url;
};
const AuthzRolesStore = singletonStore(
  "AuthzRoles",
  () => Reflux.createStore({
    listenables: [AuthzRolesActions],
    load(roleId) {
      const url = qualifyUrl(encodeApiUrl(ApiRoutes.AuthzRolesController.load, [roleId]));
      const promise = fetch("GET", url).then(Role.fromJSON);
      AuthzRolesActions.load.promise(promise);
      return promise;
    },
    delete(roleId) {
      const url = qualifyUrl(encodeApiUrl(ApiRoutes.AuthzRolesController.delete, [roleId]));
      const promise = fetch("DELETE", url);
      AuthzRolesActions.delete.promise(promise);
      return promise;
    },
    addMembers(roleId, usernames) {
      const url = encodeApiUrl(ApiRoutes.AuthzRolesController.addMembers, [roleId]);
      const promise = fetch("PUT", qualifyUrl(url), usernames.toArray());
      AuthzRolesActions.addMembers.promise(promise);
      return promise;
    },
    removeMember(roleId, username) {
      const url = encodeApiUrl(ApiRoutes.AuthzRolesController.removeMember, [roleId, username]);
      const promise = fetch("DELETE", qualifyUrl(url));
      AuthzRolesActions.removeMember.promise(promise);
      return promise;
    },
    loadUsersForRole(roleId, _roleName, { page, perPage, query }) {
      const apiUrl = encodeApiUrl(ApiRoutes.AuthzRolesController.loadUsersForRole, [roleId]);
      const url = PaginationURL(apiUrl, page, perPage, query);
      const promise = fetch("GET", qualifyUrl(url)).then(_responseToPaginatedUserList);
      AuthzRolesActions.loadUsersForRole.promise(promise);
      return promise;
    },
    loadRolesForUser(username, { page, perPage, query }) {
      const apiUrl = encodeApiUrl(ApiRoutes.AuthzRolesController.loadRolesForUser, [username]);
      const url = PaginationURL(apiUrl, page, perPage, query);
      const promise = fetch("GET", qualifyUrl(url)).then(_responseToPaginatedList);
      AuthzRolesActions.loadRolesForUser.promise(promise);
      return promise;
    },
    loadRolesPaginated({ page, perPage, query }) {
      const apiUrl = encodeApiUrl(ApiRoutes.AuthzRolesController.list);
      const url = PaginationURL(apiUrl, page, perPage, query);
      const promise = fetch("GET", qualifyUrl(url)).then(_responseToPaginatedList);
      AuthzRolesActions.loadRolesPaginated.promise(promise);
      return promise;
    }
  })
);
export { AuthzRolesActions, AuthzRolesStore };
